module.exports = __webpack_public_path__ + "img/UCL360_banner2_m.66c5aadd.png";